import styles from "../../styles/_containers/_settings/card.module.scss";

const Card = ({ children }) => (
  <div className={styles.container}>{children}</div>
);

export default Card;
